import { render, staticRenderFns } from "./KonekoAView.vue?vue&type=template&id=cb1635a4&scoped=true"
import script from "./KonekoAView.vue?vue&type=script&lang=js"
export * from "./KonekoAView.vue?vue&type=script&lang=js"
import style0 from "./KonekoAView.vue?vue&type=style&index=0&id=cb1635a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1635a4",
  null
  
)

export default component.exports